export default "__VITE_ASSET__yl0qbUa7__"